<template>
  <div class="tw:flex tw:gap-4 tw:flex-col tw:mt-4 tw:border-t tw:border-default-200 tw:pt-4">
    <div class="tw:text-sm tw:font-medium tw:text-gray-700">Debug Details (isDEV)</div>

    <div class="tw:flex tw:flex-col tw:gap-2">
      <div class="tw:flex">
        <span class="tw:body-2 tw:items-center tw:w-[10rem]">Tracker Product ID:</span>
        <span class="tw:body-2">{{ trackerProductId || "-" }}</span>
      </div>

      <div class="tw:flex tw:items-center">
        <span class="tw:body-2 tw:w-[10rem]">App ID Product ID:</span>
        <span class="tw:body-2">{{ appIdProductId || "-" }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  trackerProductId: string | null;
  appIdProductId: string | null;
}

defineProps<Props>();
</script>
